import {gsap} from "gsap";

class SpeakerCard {
    constructor(el) {
        this.el = el;
        this.pattern = el.querySelector('.pattern-object')

        this.el.addEventListener('mouseenter', () => {
            if (!this.pattern) {
                this.pattern = el.querySelector('.pattern-object')
            }
            if (!this.pattern) return;

            gsap.set(this.pattern, {svgOrigin: "50% 50%",})

            this.timeline = gsap.timeline({ paused: true, repeat: -1 })
            this.timeline.to(this.pattern, {
                rotation: 360,
                transformOrigin: "50% 50%",
                duration: 70,
                ease: "none",
                onUpdate: () => {
                    const scale = 1 + ( Math.sin(this.timeline.progress() * 4 * Math.PI) / 4);
                    gsap.set(this.pattern, {
                        scale: scale
                    })
                }
            })
            this.timeline.play()
        })

        this.el.addEventListener('mouseleave', () => {
            if(this.timeline) {
                this.timeline.pause()
            }
        })
    }
}

export default SpeakerCard
